<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Bbm7td/images/cover.jpg?1702297693445" alt="This image is the cover for the book Hitler’s Death Camps in Occupied Poland, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hitler’s Death Camps in Occupied Poland, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <p>Covers the six principal extermination camps in Nazi occupied Poland; a sobering reminder of the horrors of the Holocaust.<br/><br/>Nearly 80 years on, the concept and scale of the Nazis’ genocide program remains an indelible, nay almost unbelievable, stain on the human race. Yet it was a dreadful reality of which, as this graphic book demonstrates, all too much proof exists.  Between 1941 and 1945 an estimated three and a half million Jews and an unknown number of others, including Soviet POWs and gypsies, perished in six camps built in Poland; Auschwitz-Birkenau, Belzec, Chelmno, Majdenak, Sobibor and Treblinka.  Unpleasant as it may be, it does no harm for present generations to be reminded of man’s inhumanity to man, if only to ensure such atrocities will never be repeated.  This book aims to do just this by tracing the history of the so called Final Solution and the building and operation of the Operation Reinhard camps built for the sole purpose of mass murder and genocide.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian Baxter
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c8b6ad7